// src/features/form/formSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    identifiedBehaviour : [],
    

  
};

const jdResponsesSlice = createSlice({
  name: 'jdResponses',
  initialState,
  reducers: {
    updateJdResponsesArray: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setJdResponsesArray: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetJdResponsesArray: () => initialState,

  
  },
});

export const { updateJdResponsesArray, setJdResponsesArray, resetJdResponsesArray} = jdResponsesSlice.actions;
export default jdResponsesSlice.reducer;
